module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/radio-ca5e1546ae5ad67040bb31841660f8b5.svg";